document.addEventListener('DOMContentLoaded', transformTable);

function transformTable() {
  let tables = document.getElementsByTagName('table');

  if (tables) {
    [...tables].forEach((table) => {
      console.log(table.children[0]);
      let container = document.createElement('div');
      let header = document.createElement('div');
      let content = document.createElement('div');
      container.setAttribute('id', 'policy-table');
      header.setAttribute('id', 'table-head');
      content.setAttribute('id', 'table-body');
      header.classList.add('table-head');

      let rows = table.children[0].getElementsByTagName('tr');
      let firstRow = table.children[0].getElementsByTagName('tr')[0];

      [...firstRow.children].forEach((column) => {
        let col = document.createElement('div');
        col.classList.add('head-col');
        col.innerHTML = column.innerHTML;
        header.appendChild(col);
      });

      [...rows].forEach((row, index) => {
        if (index !== 0) {
          if (row.children.length === 1) {
            let fullRow = document.createElement('div');
            fullRow.classList.add('full-td');
            fullRow.innerHTML = row.children[0].innerHTML;
            content.appendChild(fullRow);
          } else if (row.children.length === firstRow.children.length) {
            let newRow = document.createElement('div');
            newRow.classList.add('table-row');

            [...row.children].forEach((td, i) => {
              let div = document.createElement('div');
              div.dataset.label = firstRow.children[i].textContent.trim();
              div.innerHTML = td.innerHTML;
              newRow.appendChild(div);
            });

            content.appendChild(newRow);
          }
        }
      });

      container.appendChild(header);
      container.appendChild(content);
      table.parentNode.insertBefore(container, table);

      table.parentNode.removeChild(table);
    });
  }
}
